<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Listagem de Ordens de Serviço
      </p>
    </div>

    <section class="row q-mt-sm q-mb-sm">
      <div class="col-md-2">
        <q-input
          dense
          outlined
          label="Nome da Posição"
          v-model="dados.descricao"
        />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-input dense outlined label="Alvo" v-model="dados.alvo" />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-input
          dense
          outlined
          label="Numero"
          v-model="dados.numero"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-input
          mask="##/##/####"
          dense
          outlined
          v-model="dados.data_esperada_termino"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.data_esperada_termino"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>

      <div class="col-md-3 q-ml-sm">
        <q-btn
          color="positive"
          icon="add"
          no-caps
          label="Criar Ordem"
          @click="criarOrdem"
        />
      </div>
    </section>

    <div class="q-mt-sm">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        class="tabela-tamanho-fixo"
        v-model:pagination="pagination"
        hide-pagination
        dense
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template #body-cell-name="props">
          <q-td>
            <span>
              {{ props.row.name }}
            </span>
          </q-td>
        </template>
        <template #body-cell-criacao="props">
          <q-td>
            <q-btn
              color="primary"
              round
              flat
              class="q-ml-sm"
              icon="send"
              @click="requisitar(props.row.uuid)"
            />
          </q-td>
        </template>
        <template #body-cell-remove="props">
          <q-td>
            <q-btn
              color="negative"
              round
              flat
              class="q-ml-sm"
              icon="delete"
              @click="abrirModalRemover(props.row.uuid)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <DialogConfirmDesign
      :mensagem="modalRemover.mensagem"
      :exibir="modalRemover.exibir"
      :titulo="modalRemover.titulo"
      @resultado="confirmarRemover"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "numero",
    label: "Número",
    field: "numero",
    align: "left",
  },
  {
    name: "descricao",
    label: "Nome",
    field: "descricao",
    align: "left",
  },
  {
    name: "criacao",
    label: "Requisições",
    field: "criacao",
    align: "left",
  },
  {
    name: "remove",
    label: "Remover",
    field: "remove",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  props: ["atualizar"],
  components: {
    DialogConfirmDesign,
  },
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const router = useRouter();
    let filter = ref("");
    const dados = ref({
      descricao: "",
      alvo: "",
      numero: "",
      data_esperada_termino: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const modalRemover = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Remoção",
      ordemId: null,
    });

    const getOrdem = async (page = 1, rowsPerPage = 15) => {
      let response = await store.dispatch("ordem/listarOrdem", {
        unidade: store.state.org.unidadeData.id,
        per_page: rowsPerPage,
        page: page,
        numero: filter.value,
      });

      rows.value = response.data.data;
      pagination.value.rowsPerPage = response.data.per_page;
      pagination.value.rowsNumber = response.data.total;
      pagination.value.page = response.data.current_page;

      disable.value = false;
    };

    onMounted(getOrdem);

    const criarOrdem = async () => {
      try {
        await store.dispatch("ordem/criarOrdem", {
          dados: dados.value,
        });

        $q.notify({
          message: "Ordem criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getOrdem();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar ordem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const requisitar = async (id) => {
      router.push({ name: "ordem-requisitar", params: { id: id } });
    };

    const abrirModalRemover = (id) => {
      modalRemover.value.ordemId = id;
      modalRemover.value.mensagem = "Tem certeza que deseja remover essa Ordem de Serviço?";
      modalRemover.value.exibir = true;
    };

    const confirmarRemover = async (confirmado) => {
      modalRemover.value.exibir = false;

      if (!confirmado) {
        modalRemover.value.ordemId = null;
        return;
      }

      const id = modalRemover.value.ordemId;

      try {
        await store.dispatch("ordem/removerOrdem", {
          id: id,
        });

        $q.notify({
          message: "Ordem removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getOrdem();
      } catch (error) {
        $q.notify({
          message:
            "Não é permitido deletar ordem de serviço vinculada a voucher",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalRemover.value.ordemId = null;
    };

    const remover = async (id) => {
      try {
        await store.dispatch("ordem/removerOrdem", {
          id: id,
        });

        $q.notify({
          message: "Ordem removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getOrdem();
      } catch (error) {
        $q.notify({
          message:
            "Não e permitido deletar ordem de serviço vinculada a voucher",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getOrdem(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getOrdem();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getOrdem();
      }
    );

    return {
      columns,
      rows,
      getOrdem,
      pagination,
      handleRequest,
      disable,
      filter,
      remover,
      abrirModalRemover,
      confirmarRemover,
      modalRemover,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      requisitar,
      dados,
      criarOrdem,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
